import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  createRef,
} from "react";
import {
  Container as DragContainer,
  Draggable,
} from "components/react-smooth-dnd";
import { CircularProgress, Menu, MenuItem } from "@material-ui/core";
import { get, includes } from "lodash";
import KanbanItem from "../KanbanItem";
import Scrollbars from "components/Scrollbars";
import { connect } from "react-redux";
import {
  statusSelector,
  prioritySelector,
  memberSelector,
  taskSearchSelector,
  viewPermissionsSelector,
} from "./selectors";
import { useTranslation } from "react-i18next";
import NewTask from "../../components/NewTask";
import ColumnHeader from "views/KanbanPage/components/ColumnHeader";
import { createTaskBasic } from "services/task";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import ModalCopyGroupTask from "../../../../components/WPReactTable/components/ModalCopyGroupTask";
import "../style.scss";
import "./style.scss";
import { Box } from "@mui/material";
import { ContentCopyOutlined } from "@mui/icons-material";

export const Container = ({
  className = "",
  isDragging,
  innerRef,
  ...props
}) => (
  <div
    ref={innerRef}
    className={`view_KanbanColumn___container ${className}`}
    {...props}
  />
);

const ItemList = ({ className = "", isDraggingOver, innerRef, ...props }) => (
  <Box
    ref={innerRef}
    className={`view_KanbanColumn___item-list ${className}`}
    sx={{
      scrollbarWidth: "thin",
      scrollbarColor: "CCCCCC",
      "&::-webkit-scrollbar": {
        width: "6px",
        marginRight: "12px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "none",
      },
    }}
    {...props}
  />
);

export const GroupName = ({ className = "", ...props }) => (
  <div
    className={`view_KanbanColumn___group-name ${className}`}
    {...props}
    data-custom-drag-handle={props.canUpdateProject ? "column-handle" : ""}
  />
);

export const Title = ({ className = "", ...props }) => (
  <div className={`view_KanbanColumn___title ${className}`} {...props} />
);

const ListScroll = ({ className = "", innerRef, ...props }) => {
  return (
    <Scrollbars
      className={`view_KanbanColumn___list-scroll ${className}`}
      innerRef={innerRef}
      {...props}
    />
  );
};

function KanbanColumn({
  groupTask,
  index,
  handleOpenModal,
  status,
  priority,
  memberFilter,
  projectId,
  handleItemDrop,
  stageName,
  taskSearchStr,
  viewPermissions,
}) {
  const canUpdateProject = get(
    viewPermissions.permissions,
    [projectId, "update_project"],
    false
  );
  const { t } = useTranslation();
  const [tasks, setListTasks] = useState([]);
  const [triggerEdit, setTriggerEdit] = useState(false);

  const scroller = useRef();

  const setListTask = useCallback(() => {
    console.log("priority", priority);
    return (
      get(groupTask, "tasks", [])
        .filter((task) => includes(status, get(task, "status_code", -1)))
        .filter((task) => includes(priority, get(task, "priority_code", -1)))
        // .filter((task) =>
        //   get(task, "members", [])
        //     .map((member) => get(member, "id", ""))
        //     .reduce(
        //       (result, member) => result || includes(memberFilter, member),
        //       false
        //     )
        // )
        .filter((task) => includes(get(task, "name", ""), taskSearchStr))
    );
  }, [groupTask, memberFilter, priority, status, taskSearchStr]);

  useEffect(() => {
    const taskList = setListTask();
    setListTasks(taskList);
  }, [setListTask]);

  const [moreAnchor, setMoreAnchor] = React.useState(null);
  const [addTask, setAddTask] = React.useState(false);
  const [copyGroupTask, setCopyGroupTask] = React.useState(false);
  const onCreateTaskBasic = useCallback(
    async (name, after_task_id) => {
      try {
        const result = await createTaskBasic({
          isBasic: true,
          name,
          description: "",
          priority: 2,
          project_id: projectId,
          group_task: groupTask?.id,
          after_task_id,
        });

        if (result.data.state && result.data.task) {
          let newTasks = [...tasks];
          if (after_task_id) {
            const pos = newTasks.findIndex((t) => t.id === after_task_id);
            if (pos > -1) {
              newTasks.splice(pos + 1, 0, result.data.task);
            } else {
              newTasks = [...newTasks, result.data.task];
            }
          } else {
            newTasks = [...newTasks, result.data.task];
          }
          setListTasks(newTasks);
          scrollToBottom();
          SnackbarEmitter(
            SNACKBAR_VARIANT.SUCCESS,
            DEFAULT_MESSAGE.MUTATE.SUCCESS
          );
        } else {
          SnackbarEmitter(
            SNACKBAR_VARIANT.ERROR,
            get(result.data, "msg", DEFAULT_MESSAGE.MUTATE.ERROR)
          );
        }
      } catch (error) {
        SnackbarEmitter(
          SNACKBAR_VARIANT.ERROR,
          get(error, "message", DEFAULT_MESSAGE.MUTATE.ERROR)
        );
      }
    },
    [groupTask?.id, projectId, tasks]
  );

  function handleMoreOpen(evt) {
    setMoreAnchor(evt.currentTarget);
  }

  function handleMoreClick(handler) {
    return (evt) => {
      setMoreAnchor(null);
      handler();
    };
  }

  function handleMoreClose() {
    setMoreAnchor(null);
  }

  const handleTriggerEditGroupName = () => {
    handleMoreClose();
    setTriggerEdit(true);

    setTimeout(() => {
      setTriggerEdit(false);
    }, 200);
  };

  const addTaskSuccess = useCallback(
    (newTask) => {
      const newListTask = [...tasks, newTask];
      setListTasks(() => newListTask);
    },
    [tasks, setListTasks]
  );

  const scrollToBottom = () => {
    if (!scroller.current) return;
    scroller.current.scrollToBottom();
  };

  return (
    <>
      <Container>
        <ColumnHeader
          groupTask={groupTask}
          index={index}
          iconButtons={{
            moreClick: handleMoreOpen,
            plusClick: handleMoreClick(() =>
              handleOpenModal("CREATE_TASK", {
                projectId,
                curGroupTask: groupTask,
              })
            ),
            managersClick: () =>
              handleOpenModal("MANAGERS", {
                projectId,
                groupTask,
                name: stageName.toLowerCase(),
              }),
          }}
          stageName={stageName}
          canUpdateProject={canUpdateProject}
          canManageGroupTask={canUpdateProject}
          canCreateTask={true}
          triggerEdit={triggerEdit}
        />
        <ItemList>
          <DragContainer
            onDrop={(dropResult) =>
              handleItemDrop(
                get(groupTask, "id"),
                dropResult.removedIndex,
                dropResult.addedIndex,
                dropResult.payload
              )
            }
            getChildPayload={(index) => get(tasks, `[${index}]`, {})}
            groupName="col"
            dragClass="view_KanbanItem___container-drag"
            dropClass="view_KanbanItem___container-drop"
            dragHandleSelector='[data-custom-drag-handle="item-handle"]'
            // dropPlaceholder={{
            //   animationDuration: 150,
            //   showOnTop: true,
            //   className: "view_KanbanItem___container-preview",
            // }}
            stopOverlappingAnimator={false}
          >
            {tasks.map((task, index) => {
              return (
                <Draggable key={get(task, "id")}>
                  <KanbanItem
                    task={task}
                    index={index}
                    key={index}
                    projectId={projectId}
                    handleOpenModal={handleOpenModal}
                    groupTaskId={groupTask?.id}
                    canUpdateTask={task.can_modify || canUpdateProject}
                    canDeleteTask={task.can_modify || canUpdateProject}
                    handleAddTaskSuccess={addTaskSuccess}
                    onSubmit={onCreateTaskBasic}
                  />
                </Draggable>
              );
            })}
            {addTask && (
              <NewTask
                toggleAddTask={setAddTask}
                projectId={projectId}
                groupTaskId={groupTask?.id}
                addTaskSuccess={addTaskSuccess}
                onSubmit={onCreateTaskBasic}
              />
            )}
            {canUpdateProject && (
              <div
                className="add-task-in-column"
                onClick={() => {
                  setAddTask(true);
                }}
              >
                + {t("LABEL_THEM_CONG_VIEC")}
              </div>
            )}
          </DragContainer>
        </ItemList>
        {/* <ListScroll
          autoHide
          autoHideTimeout={500}
          className={tasks.length ? "have-task" : ""}
          innerRef={scroller}
        >
          
        </ListScroll> */}
      </Container>
      <ModalCopyGroupTask
        group={groupTask}
        open={copyGroupTask}
        setOpen={setCopyGroupTask}
      />
      <Menu
        id={`${get(groupTask, "id", "")}-menu`}
        anchorEl={moreAnchor}
        open={Boolean(moreAnchor)}
        onClose={handleMoreClose}
        transformOrigin={{
          vertical: -30,
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleTriggerEditGroupName} disabled={false}>
          {false && (
            <CircularProgress
              size={16}
              className="margin-circular"
              color="white"
            />
          )}
          {t("IDS_WP_EDIT_TEXT")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setCopyGroupTask(true);
            handleMoreClose();
          }}
          disabled={false}
        >
          {t("COPY_GROUP_TASK")}
        </MenuItem>
        {/* <MenuItem
          onClick={handleMoreClick(() =>
            handleOpenModal("STAGE_SETTING", {
              stageName,
              index: index + 1,
              groupTask,
              handleOpenModal,
              projectId,
            })
          )}
          disabled={false}
        >
          {false && (
            <CircularProgress
              size={16}
              className="margin-circular"
              color="white"
            />
          )}
          {`${t("IDS_WP_SETUP")} ${stageName.toLowerCase()}`}
        </MenuItem> */}
        <MenuItem
          onClick={handleMoreClick(() =>
            handleOpenModal("DELETE_GROUPTASK", {
              selectedGroupTask: groupTask,
            })
          )}
          disabled={false}
        >
          {false && (
            <CircularProgress
              size={16}
              className="margin-circular"
              color="white"
            />
          )}
          {t("IDS_WP_DELETE")}
        </MenuItem>
      </Menu>
      <ModalCopyGroupTask />
    </>
  );
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  priority: prioritySelector(state),
  memberFilter: memberSelector(state),
  taskSearchStr: taskSearchSelector(state),
  viewPermissions: viewPermissionsSelector(state),
});

export default connect(mapStateToProps, null)(KanbanColumn);
